import { Component, OnInit, Output, EventEmitter } from '@angular/core';

export interface SatDatepickerRangeValue<D> {
  begin: D | null;
  end: D | null;
}

export interface DatepickerUpdate {
  toDate: Date;
  fromDate: Date;
}

export interface DatepickerOption {
  value: number;
  viewValue: string;
}

@Component({
  selector: 'app-datepicker-range',
  templateUrl: './datepicker-range.component.html',
  styleUrls: ['./datepicker-range.component.css']
})
export class DatepickerRangeComponent implements OnInit {

  @Output()
  dateSelected = new EventEmitter<DatepickerUpdate>();

  minDate = new Date("June 1, 2017");
  maxDate = new Date(); // today

  defaultDate = { begin: new Date(this.maxDate.getFullYear(), this.maxDate.getMonth(), this.maxDate.getDate() - 30), end: this.maxDate }; // last 30 days
  currentDate = this.defaultDate;

  date = this.defaultDate; // initial value

  options: DatepickerOption[] = [
    {value: 7, viewValue: 'Last 7 Days'},
    {value: 14, viewValue: 'Last 14 Days'},
    {value: 30, viewValue: 'Last 30 Days'},
    {value: 60, viewValue: 'Last 60 Days'},
    {value: 90, viewValue: 'Last 90 Days'}
  ];

  selected;

  constructor() { }

  ngOnInit() {
    this.onDateChange(this.date, false);
  }

  onDateChange(event: SatDatepickerRangeValue<Date>, fromOptionsSelect: boolean) {
    let dateRange: DatepickerUpdate = {fromDate: event.begin, toDate: event.end};
    this.currentDate = event;
    this.dateSelected.emit(dateRange);

    if(!fromOptionsSelect) {
      // Check to see if the date selection matches any of the predefined options
      let numDays = this.getNumDaysBetweenDates(event.begin, event.end) + 1;

      if(this.isDateEquivalent(event.end, new Date())) {
        this.options.forEach(option => {
          if(option.value == numDays) {

            setTimeout(() => {
              this.selected = numDays;
            })
            
            return;
          }
        });
      }
      
      // else
      this.selected = null;
    }
  }

  setDate(dayOffset: number) {
    // Reset maxdate to now
    this.maxDate = new Date();
    this.date = { begin: new Date(this.maxDate.getFullYear(), this.maxDate.getMonth(), this.maxDate.getDate() - dayOffset), end: this.maxDate };
 
    this.onDateChange(this.date, true);
  }

  isDateEquivalent(date1: Date, date2: Date) {
    return date1.getFullYear() == date2.getFullYear() && 
      date1.getMonth() == date2.getMonth() && 
      date1.getDate() == date2.getDate();
  }

  getNumDaysBetweenDates(date1: Date, date2: Date) {
    // The number of milliseconds in one day
    let ONE_DAY = 1000 * 60 * 60 * 24

    // Convert both dates to milliseconds
    let date1_ms = date1.getTime()
    let date2_ms = date2.getTime()

    // Calculate the difference in milliseconds
    let difference_ms = Math.abs(date1_ms - date2_ms)

    // Convert back to days and return
    return Math.round(difference_ms/ONE_DAY)
  }

}
